let footer = document.querySelector('footer.footer');
let isMobile = false;

if(window.screen.width >= 1023){
    isMobile = false;
} else {
    isMobile = true;
}

const footerFunctions = {
    /**
     * Moverá o logo do footer para uma outra posição na versão mobile
    */
    moveLogo: function() {
        let fragment = document.createDocumentFragment();

        fragment.appendChild( footer.querySelector('.footer__bottom .footer__logo') );

        footer.querySelector('.footer__middle .footer__row').appendChild( fragment );
    },

    init: function(){
        const _this = this;

        if( isMobile == true ){
            _this.moveLogo();
        }
    },
}

export default footerFunctions;